import { FC } from 'react';
import { Avatar as MuiAvatar } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  avartarVariantToTypographyMap,
  avatarVariantToSizeMap,
  stringAvatar,
  stringToColor,
} from './helpers';
import { AvatarProps } from './types';

const Avatar: FC<React.PropsWithChildren<AvatarProps>> = ({
  children,
  src,
  variant,
}) => {
  const theme = useTheme();

  const size = avatarVariantToSizeMap[variant];
  const font = avartarVariantToTypographyMap[variant];
  const { backgroundColor, color } =
    (children && stringToColor(children, theme)) || {};
  return (
    <MuiAvatar
      sx={{
        backgroundColor,
        color,
        height: size,
        typography: font,
        width: size,
      }}
      src={src}
    >
      {children && stringAvatar(children, variant)}
    </MuiAvatar>
  );
};

export default Avatar;
